import React from 'react';

const CustomIcon = ({ type, className, ...rest }) => (
    <i className={`anticon anticon-${type} ${className ? className : ''}`} {...rest} />
);

export default CustomIcon;
